<template>
  <div class="uppercase">
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="
                      w-full
                      p-3
                      font-bold
                      text-xl
                      hover:bg-blue-400
                      mt-1
                      bg-blue-600
                      text-white
                      rounded
                      shadow
                    "
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="
                  flex
                  justify-between
                  p-8
                  text-sm
                  border-t border-gray-300
                  bg-gray-100
                "
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>

    <div v-if="numero" class="bg-gray-100 p-5">
      <div class="bg-gray-200"></div>
      <div class="box-content mx-32 font-bold">
        <p
          class="
            text-blue-400
            uppercase
            shadow-xl
            rounded
            text-center
            mt-2
            bg-white
            w-auto
            p-5
          "
        >
          Mantenimiento de maestros de categorización comercial
        </p>
      </div>

      <div
        class="
          mt-7
          bg-white
          m-3
          border
          bg-gradient-to-r
          from-blue-400
          to-blue-700
          shadow
          text-center
        "
      >
        <div class="mt-3">
          <button
            @click="mostrarElemento('lineas'), cargardatoslineas()"
            :class="{ 'border bg-blue-300': !lineas }"
            class="
              mx-4
              items-baseline
              shadow
              uppercase
              text-white
              hover:text-black
              hover:bg-blue-300
              rounded
              p-1
              m-2
              inline
            "
          >
            <a href="#"> Lineas </a>
            <div class="border bg-black">
              <hr v-if="!lineas" id="color" size="4" />
            </div>
          </button>

          <button
            :class="{ 'border bg-blue-300': !talla }"
            @click="mostrarElemento('talla'), cargardatostalla()"
            class="
              mx-4
              shadow
              uppercase
              text-white
              hover:text-black
              hover:bg-blue-300
              rounded
              p-1
              m-2
            "
          >
            <a href="#"> Talla</a>
            <div class="border bg-black">
              <hr v-if="!talla" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !colores }"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              text-white
              uppercase
              rounded
              p-1
              m-2
            "
            @click="mostrarElemento('colores'), cargardatoscolores()"
          >
            <a href="#"> Colores</a>
            <div class="border bg-black">
              <hr v-if="!colores" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !categorias }"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              text-white
              uppercase
              m-2
            "
            @click="mostrarElemento('categorias'), cargardatoscategorias()"
          >
            <a href="#"> Categorias</a>
            <div class="border bg-black">
              <hr v-if="!categorias" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !generos }"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              text-white
              uppercase
            "
            @click="mostrarElemento('generos'), cargardatosgeneros()"
          >
            <a href="#"> Generos</a>
            <div class="border bg-black">
              <hr v-if="!generos" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !niveles }"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              uppercase
              text-white
            "
            @click="mostrarElemento('niveles'), cargardatosniveles()"
          >
            <a href="#"> Niveles</a>
            <div class="border bg-black">
              <hr v-if="!niveles" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !targets }"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              uppercase
              text-white
            "
            @click="mostrarElemento('targets'), cargardatostargets()"
          >
            <a href="#"> Targets</a>
            <div class="border bg-black">
              <hr v-if="!targets" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !grupos }"
            @click="mostrarElemento('grupos'), cargardatosgrupos()"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              uppercase
              text-white
            "
          >
            <a href="#"> Grupos</a>
            <div class="border bg-black">
              <hr v-if="!grupos" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !caracteristicas }"
            @click="
              mostrarElemento('caracteristicas'), cargardatoscaracteristicas()
            "
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              uppercase
              text-white
            "
          >
            <a> Caracteristicas</a>
            <div class="border bg-black">
              <hr v-if="!caracteristicas" id="color" size="4" />
            </div>
          </button>
          <button
            :class="{ 'border bg-blue-300': !marcas }"
            @click="mostrarElemento('marcas'), cargardatosmarcas()"
            class="
              mx-4
              shadow
              hover:bg-blue-300
              hover:text-black
              rounded
              p-1
              m-2
              uppercase
              text-white
            "
          >
            <a> Marcas</a>
            <div class="border bg-black">
              <hr v-if="!marcas" id="color" size="4" />
            </div>
          </button>

          <!--mostrar lineas-->
          <div v-if="!lineas">
            <div class="bg-gray-100 grid justify-items-start">
              <div>
                <!-- <button
              class="bg-green-500 text-white mt-7 border-blue-100 rounded p-2 m-4"
            >
              <img
                width="25px"
                src="https://image.flaticon.com/icons/png/512/61/61444.png"
                alt=""
              />
            </button> -->
              </div>

              <tablaLineas></tablaLineas>
            </div>
          </div>

          <!--mostrar tallas-->

          <div v-if="!talla">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaTallas></tablaTallas>
              <modalTalla></modalTalla>
            </div>
          </div>

          <!--mostrar Colores-->
          <div v-if="!colores">
            <div class="bg-gray-100 grid justify-items-start">
              <modalColores></modalColores>
              <tablaColores></tablaColores>
            </div>
          </div>
          <!--mostrar Categorias-->
          <div v-if="!categorias">
            <div class="bg-gray-100 grid justify-items-start">
              <modalCategorias></modalCategorias>
              <tablaCategorias></tablaCategorias>
            </div>
          </div>
          <!--mostrar Genero-->
          <div v-if="!generos">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaGeneros></tablaGeneros>
              <modalGeneros></modalGeneros>
            </div>
          </div>

          <!--mostrar Niveles-->
          <div v-if="!niveles">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaNiveles></tablaNiveles>
              <modalNiveles></modalNiveles>
            </div>
          </div>
          <!--mostrar target-->
          <div v-if="!targets">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaTargets></tablaTargets>
              <modalTargets></modalTargets>
            </div>
          </div>

          <!--mostrar Grupos-->
          <div v-if="!grupos">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaGrupos></tablaGrupos>
              <modalGrupos></modalGrupos>
            </div>
          </div>
          <div v-if="!marcas">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaMarcas></tablaMarcas>
              <modalMarcas></modalMarcas>
            </div>
          </div>

          <!--mostrar caracteristicas-->
          <div class="bg-gray-100" v-if="!caracteristicas">
            <div class="bg-gray-100 grid justify-items-start">
              <tablaCaracteristicas></tablaCaracteristicas>
              <modalCaracteristicas></modalCaracteristicas>
            </div>
          </div>
        </div>
      </div>
      <modalLineas></modalLineas>
      <modalCaracteristicas></modalCaracteristicas>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import tablaCaracteristicas from "../components/Tablas/tablaCaracteristicas.vue";

import modalCaracteristicas from "../components/modales/modalCaracteristicas.vue";
import modalLineas from "../components/modales/modalLineas.vue";
import TablaLineas from "../components/Tablas/TablaLineas.vue";
import tablaTallas from "../components/Tablas/tablaTallas.vue";
import modalTalla from "../components/modales/modalTalla.vue";
import modalColores from "../components/modales/modalColores.vue";
import tablaColores from "../components/Tablas/tablaColores.vue";
import tablaCategorias from "../components/Tablas/tablaCategorias.vue";
import modalCategorias from "../components/modales/modalCategorias.vue";
import tablaGeneros from "../components/Tablas/tablaGeneros.vue";
import modalGeneros from "../components/modales/modalGeneros.vue";
import tablaNiveles from "../components/Tablas/tablaNiveles.vue";
import modalNiveles from "../components/modales/modalNiveles.vue";
import tablaTargets from "../components/Tablas/tablaTargets.vue";
import modalTargets from "../components/modales/modalTargets.vue";
import tablaGrupos from "../components/Tablas/tablaGrupos.vue";
import modalGrupos from "../components/modales/modalGrupos.vue";
import modalMarcas from "../components/modales/modalMarcas.vue";
import tablaMarcas from "../components/Tablas/tablaMarcas.vue";

export default {
  components: {
    modalCaracteristicas,
    modalLineas,
    modalCategorias,
    tablaCategorias,
    tablaColores,
    modalColores,
    TablaLineas,
    tablaTallas,
    modalTalla,
    tablaCaracteristicas,
    tablaGeneros,
    modalGeneros,
    tablaNiveles,
    modalNiveles,
    tablaTargets,
    modalTargets,
    tablaGrupos,
    modalGrupos,
    modalMarcas,
    tablaMarcas,
  },
  name: "caracteristicas",
  data() {
    return {
      falso: true,
      lineas: true,
      talla: true,
      colores: true,
      categorias: true,
      generos: true,
      niveles: true,
      targets: true,
      grupos: true,
      marcas: true,
      caracteristicas: true,
      value: null,
    };
  },
  computed: {
    ...mapState(["numero"]),
  },
  methods: {
    ...mapMutations(["value0", "value1"]),
    ...mapMutations("lineas", ["cargardatoslineas"]),
    ...mapMutations("tallas", ["cargardatostalla"]),
    ...mapMutations("colores", ["cargardatoscolores"]),
    ...mapMutations("categorias", ["cargardatoscategorias"]),
    ...mapMutations("generos", ["cargardatosgeneros"]),
    ...mapMutations("niveles", ["cargardatosniveles"]),
    ...mapMutations("targets", ["cargardatostargets"]),
    ...mapMutations("grupos", ["cargardatosgrupos"]),
    ...mapMutations("marcas", ["cargardatosmarcas"]),
    ...mapMutations("caracteristicas", ["cargardatoscaracteristicas"]),
    //...mapMutations("", ["cargardatos"]),

    mostrarElemento(grupo) {
      switch (grupo) {
        case "generos":
          (this.niveles = true),
            (this.generos = false),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "niveles":
          (this.niveles = false),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;
        case "lineas":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = false),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "talla":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = false),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "colores":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = false),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "categorias":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = false),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "targets":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = false),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "grupos":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = false),
            (this.marcas = true),
            (this.caracteristicas = true);
          break;

        case "caracteristicas":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.marcas = true),
            (this.caracteristicas = false);
          break;
        case "marcas":
          (this.niveles = true),
            (this.generos = true),
            (this.lineas = true),
            (this.talla = true),
            (this.colores = true),
            (this.categorias = true),
            (this.targets = true),
            (this.grupos = true),
            (this.caracteristicas = true),
            (this.marcas = false);
          break;
      }
    },
  },
};
</script>
<style scoped>
.navbar {
  /*overflow: hidden;*/
  background-color: rgb(0, 0, 0);
  font-family: Arial;
}

/* Links inside the navbar */
.navbar a {
  float: left;
  font-size: 16px;
  color: white;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}

/* The dropdown container */
.dropdown {
  float: left;
  /* overflow: hidden;*/
}

/* Dropdown button */
.dropdown .dropbtn {
  font-size: 16px;
  border: none;
  outline: none;
  color: white;
  padding: 14px 16px;
  background-color: inherit;
  font: inherit; /* Important for vertical align on mobile phones */
  margin-top: 14px; /* Important for vertical align on mobile phones */
}

/* Add a red background color to navbar links on hover */
.navbar a:hover,
.dropdown:hover .dropbtn {
  background-color: red;
}

/* Dropdown content (hidden by default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  width: 100%;
  left: 0;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Mega Menu header, if needed */
.dropdown-content .header {
  background: rgb(255, 0, 0);
  padding: 16px;
  color: white;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 33.33%;
  padding: 10px;
  background-color: rgb(216, 215, 215);
  height: 255px;
}

/* Style links inside the columns */
.column a {
  float: none;
  color: black;
  padding: 10px;
  text-decoration: none;
  display: block;
  text-align: left;
}

/* Add a background color on hover */
.column a:hover {
  background-color: #ddd;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
hr#color {
  border-top: 2px solid rgb(0, 0, 0);
}
</style>